module.exports = __webpack_public_path__ + "293b95ea7f0389ea0c8a37e2403ed79a.png";